import React from "react";
import styled from "styled-components";
import PartWithUsImg1 from "../../../assets/partner-with-us-img1.svg";
import PartWithUsImg2 from "../../../assets/partner-with-us-img2.svg";
import PartWithUsImg3 from "../../../assets/partner-with-us-img3.svg";
import PartWithUsImg4 from "../../../assets/partner-with-us-img4.svg";
import PartWithUsImg5 from "../../../assets/partner-with-us-img5.svg";
import PartWithUsImg6 from "../../../assets/partner-with-us-img6.svg";
import BackgroundImage from "../../../assets/bg.png";
import { useTranslation } from "react-i18next";
import { SectionDescriptionCardComponent } from "../../../components/section-desc-card/section-description-card.component";

const PartnerWithUsContainer = styled.div`




  width: 100%;
  max-width: 1400px;
  display: flex;
  justify-content: center;
    @media (max-width: 1025px) {
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
  }
  @media (max-width: 480px) {
    flex-direction: column-reverse;
    max-width: 480px; 
    align-items: center;
  };

`;
const PartnerWithUsWrapper = styled.div.attrs({
  id: "partnership",
})`

  background: url(${BackgroundImage}) center center fixed;
  -webkit-background-size: cover;

  width: 100%;
  display: flex;
  justify-content: center;
  padding: 100px 0;
  background-color: rgba(29, 109, 193, 0.05);
  @media (max-width: 480px) {
    padding: 50px 0;
  }
`;
const PartnerWithUsImages = styled.div`
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  padding-right: 64px;
    @media (max-width: 1025px) {
    width: 100%;
    padding-right: 0px;
  }
  @media (max-width: 480px) {
    width: 100%;
    padding-right: 0px;
  }

`;
const PartnerWithUsImageWrapper = styled.figure`
  width: calc(100% / 2);
  padding: 22px 14px 22px 14px;
  position: relative;
  overflow: hidden;
      display: flex;
    justify-content: center;
      @media (max-width: 1025px) {
    padding: 14px;

  }
  @media (max-width: 480px) {
    padding: 14px;
  }

`;
const PartnerWithUsImage = styled.img`
  width: 90%;
    @media (max-width: 1025px) {
  }
  @media (max-width: 480px) {
    width: 100%;
  }

`;
const PartnerWithUsImageDesc = styled.p`
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 1);
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  @media (max-width: 480px) {
    top: 68%;
    font-size: 12px;
  }
`;

export const PartnerWithUs = ({ setModalOpen, setIsPartnerWithUs }) => {
  const { t } = useTranslation();
  return (
    <PartnerWithUsWrapper>
      <PartnerWithUsContainer>
        <PartnerWithUsImages>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg1} alt="" />
            <PartnerWithUsImageDesc>{t('partner-with-us-sec-img1-desc')}</PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg2} alt="" />
            <PartnerWithUsImageDesc>{t('partner-with-us-sec-img2-desc')}</PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg3} alt="" />
            <PartnerWithUsImageDesc>{t('partner-with-us-sec-img3-desc')}</PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg4} alt="" />
            <PartnerWithUsImageDesc>{t('partner-with-us-sec-img4-desc')}</PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg5} alt="" />
            <PartnerWithUsImageDesc>{t('partner-with-us-sec-img5-desc')}</PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
          <PartnerWithUsImageWrapper>
            <PartnerWithUsImage src={PartWithUsImg6} alt="" />
            <PartnerWithUsImageDesc>
              {t('partner-with-us-sec-img6-desc')}
            </PartnerWithUsImageDesc>
          </PartnerWithUsImageWrapper>
        </PartnerWithUsImages>
        <SectionDescriptionCardComponent
          label={t('partner-us-label-1')}
          heading={t('partner-us-heading-1')}
          para={{
            intro:
          t('partner-us-para-1')    
          }}
          buttons={1}
          button_primary={t('partner-us-btn-1')}
          option1GoTo="modal"
          setModalOpen={setModalOpen}
          setIsPartnerWithUs={setIsPartnerWithUs}
          // button_secondary={"Contact us"}
        />
      </PartnerWithUsContainer>
    </PartnerWithUsWrapper>
  );
};
